<template>
  <div class="outer-wrapper">
    <div v-if="currentShow === 'list'">
      <div class="title-wrapper">
        <p>检测意向</p>
        <van-icon name="add-o" class="add-b" @click="() => (sw.add = true)" />
      </div>
      <van-search v-model="optionData.keyword" placeholder="请输入搜索关键词" />
      <van-list
        v-model="tableList.loading"
        :finished="tableList.finished"
        finished-text="没有更多了"
        :error.sync="tableList.error"
        error-text="请求失败，点击重新加载"
        @load="onLoad"
      >
        <van-swipe-cell
          v-for="(item, index) in tableList.tivdata"
          :key="index + 'su'"
        >
          <van-cell
            :title="item.sample_name"
            :value="item.category"
            is-link
            @click="viewItem(item)"
          >
            <template #label>
              <div>
                <p>{{ item.manufacturer_name }}</p>
                <p>{{ item.wc_name }}</p>
              </div>
            </template>
          </van-cell>
          <template #right>
            <van-button
              square
              type="danger"
              text="删除"
              style="height: 100%"
              @click="intentionDelConfirmBox(item)"
            />
          </template>
        </van-swipe-cell>
      </van-list>
    </div>
    <div v-else>
      <van-nav-bar
        title="检测意图详情"
        left-text="返回"
        left-arrow
        @click-left="goBack"
        fixed
      >
      </van-nav-bar>
      <van-swipe-cell>
        <van-cell center title="编号" :value="currentItem.display_no" />
        <template #right>
          <van-button
            square
            type="warning"
            text="修改"
            style="height: 100%"
            @click="itemAlter('display_no', '编号')"
          />
        </template>
      </van-swipe-cell>
      <van-swipe-cell>
        <van-cell center title="项目名称" :value="currentItem.wc_name" />
        <template #right>
          <van-button
            square
            type="warning"
            text="修改"
            style="height: 100%"
            @click="itemAlter('wc_name', '项目名称')"
          />
        </template>
      </van-swipe-cell>
      <van-swipe-cell>
        <van-cell
          center
          title="生产厂家"
          :value="currentItem.manufacturer_name"
        />
        <template #right>
          <van-button
            square
            type="warning"
            text="修改"
            style="height: 100%"
            @click="itemAlter('manufacturer_name', '生产厂家')"
          />
        </template>
      </van-swipe-cell>
      <van-swipe-cell>
        <van-cell center title="样品名称" :value="currentItem.sample_name" />
        <template #right>
          <van-button
            square
            type="warning"
            text="修改"
            style="height: 100%"
            @click="itemAlter('sample_name', '样品名称')"
          />
        </template>
      </van-swipe-cell>
      <van-swipe-cell>
        <van-cell center title="型号/规格" :value="currentItem.spec" />
        <template #right>
          <van-button
            square
            type="warning"
            text="修改"
            style="height: 100%"
            @click="itemAlter('spec', '型号/规格')"
          />
        </template>
      </van-swipe-cell>
      <van-swipe-cell>
        <van-cell center title="检测类别" :value="currentItem.category" />
        <template #right>
          <van-button
            square
            type="warning"
            text="修改"
            style="height: 100%"
            @click="itemAlter('category', '检测类别')"
          />
        </template>
      </van-swipe-cell>
      <van-swipe-cell>
        <van-cell center title="备注" :value="currentItem.remark" />
        <template #right>
          <van-button
            square
            type="warning"
            text="修改"
            style="height: 100%"
            @click="itemAlter('remark', '备注')"
          />
        </template>
      </van-swipe-cell>
      <van-swipe-cell
        v-for="(co, index) in currentItem.corporationList"
        :key="index"
      >
        <van-cell :title="co.category" :value="co.name">
          <template #label>
            <div class="cor-label">
              <p>{{ co.address }}</p>
              <p
                v-for="(p, subi) in co.c_person"
                :key="subi"
                class="person-p-w"
              >
                <span>{{ p.name }}</span>
                <span>{{ p.phone }}</span>
                <span>{{ p.role }}</span>
              </p>
            </div>
          </template>
        </van-cell>
        <template #right>
          <van-button
            square
            type="danger"
            text="删除"
            style="height: 100%"
            @click="corporationDel(co.id, index)"
          />
        </template>
      </van-swipe-cell>
      <van-button type="info" block @click="addCorporation"
        >添加相关单位</van-button
      >
    </div>

    <van-dialog
      v-model="sw.add"
      title="新建检测意向"
      show-cancel-button
      @confirm="handleSubmit"
    >
      <div>
        <p class="s-w">
          <span>项目：</span>

          <span
            ><select v-model="intention.wc_id" placeholder="请选择所属项目">
              <option
                v-for="(ele, index) in wcList"
                :key="index"
                :value="ele.id"
              >
                {{ ele.name }}
              </option>
            </select></span
          >
          <span class="wc-add-icon">
            <van-icon name="add" title="添加项目" :size="20" @click="addWc" />
          </span>
        </p>
        <van-field
          v-model="intention.manufacturer_name"
          label="生产厂家："
          label-align="right"
        />
        <van-field
          v-model="intention.sample_name"
          label="样品名称："
          label-align="right"
        />
        <van-field
          v-model="intention.spec"
          label="型号/规格："
          label-align="right"
        />
        <van-field
          v-model="intention.category"
          label="检测类型："
          label-align="right"
        />
        <van-field
          v-model="intention.display_no"
          label="编号："
          label-align="right"
        />
        <van-field
          v-model="intention.price"
          label="价格："
          label-align="right"
        />
        <van-field
          v-model="intention.remark"
          label="备注："
          label-align="right"
        />
      </div>
    </van-dialog>
    <van-dialog
      v-model="sw.corporation"
      title="添加相关单位"
      show-cancel-button
      @confirm="handleSubmitCorporation"
    >
      <div>
        <p class="s-w">
          <span>单位类型：</span>

          <span
            ><input v-model="corporation.category" list="d" class="s-input" />
            <datalist id="d">
              <option>委托单位</option>
            </datalist></span
          >
        </p>
        <van-field
          v-model="corporation.name"
          label="单位名称："
          label-align="right"
        />
        <van-field
          v-model="corporation.address"
          label="地址："
          label-align="right"
        />

        <div class="person-wrapper">
          <p class="s-w">
            <span>联系人：</span>
          </p>
          <div
            v-for="(item, index) in corporation.c_person"
            :key="index"
            class="person-ele"
          >
            <p class="person-p">
              <label for=""
                >姓名：<input type="text" v-model="item.name" placeholder=""
              /></label>
            </p>
            <p class="person-p">
              <label for=""
                >职务：<input type="text" v-model="item.role" placeholder=""
              /></label>
            </p>
            <p class="person-p">
              <label for=""
                >电话：<input type="text" v-model="item.phone" placeholder=""
              /></label>
            </p>
          </div>
          <p style="text-align: center; padding: 0.8rem">
            <van-button @click="addPerson" type="primary"
              >添加联系人</van-button
            >
          </p>
        </div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="sw.alter"
      :title="'修改' + currentText"
      show-cancel-button
      @confirm="alterSubmit"
    >
      <div class="i-wrapper-h">
        <input type="text" v-model="currentValue" class="s-input" />
      </div>
    </van-dialog>
  </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");
// import { textTrans } from "@/mixins/TextTrans.js";

function myTableFac() {
  return {
    loading: false,
    finished: false,
    error: false,
    Tpage: {
      currentPage: 1,
      currentSize: 20,
    },
    no_data_text: "",
    totalItems: 0,
    tivdata: [],
  };
}

const OPTIONDATA = {
  category: [
    { text: "全部状态", value: "" },
    { text: "厂家送检", value: "厂家送检" },
    { text: "现场送检", value: "现场送检" },
  ],
  order: [
    { text: "默认排序", value: "" },
    { text: "要求日期", value: "demand" },
    { text: "委托日期", value: "create" },
  ],
  esc: [
    { text: "排序方向", value: "DESC" },
    { text: "倒序", value: "DESC" },
    { text: "顺序", value: "ESC" },
  ],
};

function optionDataFac() {
  return {
    wc_name: "",
    manufacturer_name: "",
    sample_name: "",
    category: OPTIONDATA.category[0].value,
    keyword: "",
    order: "",
    esc: OPTIONDATA.esc[0].value,
  };
}

function intentionFac() {
  return {
    id: 0,
    wc_id: null,
    sample_name: "",
    spec: "",
    manufacturer_name: "",
    category: "",
    remark: "",
    display_no: "",
    final_price: 0,
    corporationList: [],
  };
}

function corporationFac() {
  return {
    rp_id: 0,
    name: "",
    category: "",
    address: "",
    c_person: [],
  };
}

function personFac() {
  return {
    name: "",
    role: "",
    phone: "",
  };
}

export default {
  name: "rpManage",
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      currentTab: 0,
      currentEquipment: {
        name: "",
        equipnum: "",
      },
      tableList: myTableFac(),
      optionData: optionDataFac(),
      sw: {
        add: false,
        corporation: false,
        alter: false,
      },
      intention: intentionFac(),
      wcList: [],
      currentShow: "list",
      currentItem: intentionFac(),
      corporation: corporationFac(),
      currentLabel: "",
      currentText: "",
      currentValue: "",
    };
  },
  watch: {},
  computed: {},
  created() {
    // this.getData();
    this.getStaticOptions();
    this.getActiveOptions();
  },
  mounted() {},
  methods: {
    onSearch() {
      this.tableList = myTableFac();
      this.onLoad();
    },
    viewItem(item) {
      this.$axios
        .post(this.$url + "/intention", {
          rp_id: item.id,
          askData: "relationCorporation",
          userToken: userToken,
        })
        .then((response) => {
          if (response.data.stat === "ok") {
            this.currentItem = item;
            this.currentItem.corporationList = response.data.res_record;
            this.currentShow = "item";
          } else {
            this.$toast.fail(response.data.info);
          }
        });
    },
    getStaticOptions() {
      this.$axios
        .post(this.$url + "/ask_static_options", {
          userToken: userToken,
          ask_data: "intentionList",
        })
        .then((response) => {
          if (response.data.stat === "ok") {
            this.staticOptions = response.data.res_record;
            this.optionData.category = this.staticOptions.category[0].value;
          } else {
            this.$toast.fail("请求选项数据失败！");
          }
        })
        .catch((error) => {
          this.$toast.fail(error + "网络错误！操作失败。");
        });
    },
    addPerson() {
      this.corporation.c_person.push(personFac());
    },
    getActiveOptions() {
      this.$axios
        .post(this.$url + "/ask_option_data", {
          userToken: userToken,
          ask_data: "wcList",
        })
        .then((response) => {
          if (response.data.stat === "ok") {
            this.wcList = response.data.res_record;
            this.intention.wc_id = this.wcList[0].id;
          } else {
            this.$toast.fail("未找到选项数据");
          }
        })
        .catch((error) => {
          this.$toast.fail(error + "网络错误！操作失败。");
        });
    },
    // getData() {
    //   this.$axios
    //     .post(this.$url + "/ask_list_data", {
    //       userToken: userToken,
    //       ask_data: "rpList",
    //       enid: this.enid,
    //     })
    //     .then((response) => {
    //       if (response.data.stat === "ok") {
    //         this.currentEquipment = response.data.res_record;
    //         this.currentEquipment.useStat = response.data.useStat;
    //       } else {
    //         this.$toast.fail("未找到数据！");
    //       }
    //     });
    // },
    onLoad() {
      this.tableList.loading = true;
      this.$axios
        .post(this.$url + "/ask_list_data", {
          page: this.tableList.Tpage,
          userToken: userToken,
          ask_data: "rpList",
          enid: this.enid,
          optionData: this.optionData,
        })
        .then((response) => {
          for (let ele of response.data.res_record) {
            this.tableList.tivdata.push(ele);
          }
          if (
            response.data.res_record.length < this.tableList.Tpage.currentSize
          ) {
            this.tableList.finished = true;
          }
          this.tableList.loading = false;
          this.tableList.Tpage.currentPage++;
        });
    },
    goBack() {
      this.currentShow = "list";
    },
    addWc() {
      location.href = "/intention/wcManage/y";
    },
    handleSubmit() {
      let form = new FormData();
      form.append("userToken", userToken);
      form.append("askData", "createOne");
      form.append("intention", JSON.stringify(this.intention));
      let config = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      this.$axios
        .post(this.$url + "/intention", form, config)
        .then((response) => {
          if (response.data.stat === "ok") {
            this.$toast.success("数据添加成功！");
            this.onSearch();
          } else {
            this.$toast.fail(response.data.stat);
          }
        })
        .catch((error) => {
          this.$toast.fail(error + "未知错误！");
        });
    },
    handleSubmitCorporation() {
      let form = new FormData();
      form.append("userToken", userToken);
      form.append("askData", "newCorporation");
      form.append("corporation", JSON.stringify(this.corporation));
      let config = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      this.$axios
        .post(this.$url + "/intention", form, config)
        .then((response) => {
          if (response.data.stat === "ok") {
            this.$toast.success("数据添加成功！");
            this.currentItem.corporationList.push(this.corporation);
            this.$forceUpdate();
          } else {
            this.$toast.fail(response.data.stat);
          }
        })
        .catch((error) => {
          this.$toast.fail(error + "未知错误！");
        });
    },
    addCorporation() {
      this.corporation = corporationFac();
      this.corporation.rp_id = this.currentItem.id;
      this.sw.corporation = true;
    },
    corporationDel(cid, index) {
      this.$axios
        .post(this.$url + "/intention", {
          cid: cid,
          rp_id: this.currentItem.id,
          askData: "corporationDel",
          userToken: userToken,
        })
        .then((response) => {
          if (response.data.stat === "ok") {
            this.$toast.success("删除成功!");
            this.currentItem.corporationList.splice(index, 1);
            this.$forceUpdate();
          } else {
            this.$toast.fail(response.data.info);
          }
        });
    },
    intentionDelConfirmBox(value) {
      this.$dialog
        .confirm({
          title: "确认删除：",
          message: "检测意图：" + value.sample_name,
        })
        .then(() => {
          this.recordDel(value.id, "intentionDel");
        })
        .catch(() => {});
    },
    recordDel(id, label) {
      this.$axios
        .post(this.$url + "/intention", {
          pid: id,
          askData: label,
          userToken: userToken,
        })
        .then((response) => {
          if (response.data.stat === "ok") {
            this.$toast.success("删除成功！");
            this.onSearch();
          } else {
            this.$toast.fail(response.data.info);
          }
        });
    },
    itemAlter(label, text) {
      this.currentLabel = label;
      this.currentText = text;
      this.currentValue = this.currentItem[label];
      this.sw.alter = true;
    },
    alterSubmit() {
      let form = new FormData();
      form.append("userToken", userToken);
      form.append("askData", "alterRp");
      form.append("rp_id", this.currentItem.id);
      form.append("label", this.currentLabel);
      form.append("value", this.currentValue);
      let config = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      this.$axios
        .post(this.$url + "/intention", form, config)
        .then((response) => {
          if (response.data.stat === "ok") {
            this.currentItem[this.currentLabel] = this.currentValue;
            this.$toast.success("数据修改成功！");
            this.sw.alter = false;
          } else {
            this.$toast.fail(response.data.info);
          }
        })
        .catch((error) => {
          this.$toast.fail(error + "未知错误！");
        });
    },
  },
};
</script>
<style scoped>
.inner-wrapper {
  width: 100%;
  background: #f7f7f7;
  min-height: 20rem;
}

.title-wrapper {
  text-align: center;
  font-size: 0.8rem;
  color: #999;
  padding: 1rem;
  background: #fff;
  border-bottom: 1px solid #f6f6f6;
  position: relative;
}

.add-b {
  position: absolute;
  right: 1.2rem;
  top: 1.2rem;
}

.editor-wrapper {
  width: 100%;
}
.cell-item {
  margin-left: 0.6rem;
}

.op {
  outline: none;
  border: 1px solid #eee;
  color: #fff;
  background: rgb(11, 155, 18);
  font-weight: 400;
  height: 1rem;
  position: relative;
  top: 0.05rem;
  padding: 0.15rem 0.5rem;
  border-radius: 0.2rem;
}
.deny {
  background: rgb(228, 46, 14);
  margin-left: 0.5rem;
}

.text-wrapper {
  padding: 0.1rem 0.5rem;
}
.text-wrapper-con {
  padding: 1rem 0 1rem 2rem;
}

.textarea {
  width: 100%;
  height: 7rem;
}
.bold-text {
  font-weight: 600;
  color: #666;
}
.d-wrapper {
  padding: 0.5rem 1rem;
  text-align: center;
  font-size: 0.6rem;
}
.button-wrapper {
  padding: 2rem;
  text-align: center;
}
.radio-item {
  margin-top: 1rem;
  margin-left: 30%;
}

.cell-title {
  overflow: hidden;
  word-break: break-all;
}

.s-w {
  border-bottom: 1px solid #eee;
  padding: 0.8rem;
  height: 1.4rem;
}

.s-w span:first-child {
  display: inline-block;
  width: 30%;
  text-align: right;
  font-size: 0.7rem;
  color: #666;
}

.s-w select {
  padding: 0.1rem 0.3rem;
  text-align: center;
  border: none;
}

.wc-add-icon {
  position: relative;
  top: 0.25rem;
  left: 0.2rem;
}

.person-p-w span {
  margin: 0 0.2rem;
}

.cor-label {
  text-align: right;
  width: 200%;
}

.person-ele {
  border: 1px dashed #ccc;
  margin-bottom: 0.6rem;
  padding: 0.3rem;
}

.person-p {
  padding: 0.1rem 0;
  text-align: right;
  border-bottom: 1px solid #eee;
}

.person-wrapper input {
  border: none;
}

.s-input {
  border: none;
  text-align: center;
}

.i-wrapper-h {
  padding: 1rem 0;
  text-align: center;
}

.i-wrapper-h input {
  border-bottom: 1px solid #ccc;
  padding: 0.2rem;
}
</style>